<div class="card">
  <div class="card-header">
    <h1>Reporte Venta por Cliente y Producto</h1>
  </div>
  <div class="card-body">
    <div class="row align-items-end">
      <!-- Filtro de Fechas -->
      <div class="col-md-3">
        <label for="startDate">Fecha de Inicio:</label>
        <input
          type="date"
          class="form-control"
          id="startDate"
          [(ngModel)]="startDate"
        />
      </div>

      <div class="col-md-3">
        <label for="endDate">Fecha de Fin:</label>
        <input
          type="date"
          class="form-control"
          id="endDate"
          [(ngModel)]="endDate"
        />
      </div>

      <!-- Filtro de Productos -->
      <div class="col-md-4">
        <app-input-autocomplete-selection
          [inputs]="inputs.product"
          [placeholder]="'Ingresa id o nombre de un producto'"
          [filterElements]="filterProducts"
          [typeElements]="'product'"
          [enableSelect]="true"
          (inputMethod)="handleInput($event.event, 'product')"
          (changeMethod)="verifiedInput($event.event, 'product')"
          (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'product')"
          (getTitle)="
            $event.filterElement.title = 
            (($event.filterElement.code) ? $event.filterElement.code + ' - ' : '') + 
            $event.filterElement.name
          ">
        </app-input-autocomplete-selection>
      </div>

      <!-- Botón de Búsqueda -->
      <div class="col-md-2">
        <button
          class="btn btn-primary w-100"
          (click)="executeSearch()">
          🔍 Buscar
        </button>
      </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="table-responsive mt-3">
            <table class="table table-bordered" style="margin-bottom: 0;">
                <thead>
                  <tr class="text-center">
                    <th>Cliente</th>
                    <th>Bodega</th>
                    <th>Producto</th>
                    <th>
                      Unidades
                      <i
                        class="fa"
                        (click)="sortByColumn('totalUnits'); $event.stopPropagation()"
                        [ngClass]="{
                          'fa-arrow-right-arrow-left': sortColumn !== 'totalUnits',
                          'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'totalUnits',
                          'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'totalUnits'
                        }"
                      ></i>
                    </th>
                    <th>
                      Venta
                      <i
                        class="fa"
                        (click)="sortByColumn('totalSales'); $event.stopPropagation()"
                        [ngClass]="{
                          'fa-arrow-right-arrow-left': sortColumn !== 'totalSales',
                          'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'totalSales',
                          'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'totalSales'
                        }"
                      ></i>
                    </th>
                    <th>
                      Costo
                      <i
                        class="fa"
                        (click)="sortByColumn('totalCost'); $event.stopPropagation()"
                        [ngClass]="{
                          'fa-arrow-right-arrow-left': sortColumn !== 'totalCost',
                          'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'totalCost',
                          'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'totalCost'
                        }"
                      ></i>
                    </th>
                    <th>
                      Utilidad
                      <i
                        class="fa"
                        (click)="sortByColumn('totalProfit'); $event.stopPropagation()"
                        [ngClass]="{
                          'fa-arrow-right-arrow-left': sortColumn !== 'totalProfit',
                          'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'totalProfit',
                          'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'totalProfit'
                        }"
                      ></i>
                    </th>
                    <th>
                      Margen
                      <i
                        class="fa"
                        (click)="sortByColumn('totalMargin'); $event.stopPropagation()"
                        [ngClass]="{
                          'fa-arrow-right-arrow-left': sortColumn !== 'totalMargin',
                          'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === 'totalMargin',
                          'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === 'totalMargin'
                        }"
                      ></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let client of filteredResults">
                    <!-- Client Row -->
                    <tr class="fw-bold" (click)="toggleClient(client)">
                    <td>
                        <i class="fa" [ngClass]="client.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                        {{ client.name }}
                    </td>
                    <td></td>
                    <td></td>
                    <td>{{ client.totalUnits }}</td>
                    <td>{{ client.totalSales | currency:'Q.' }}</td>
                    <td>{{ client.totalCost | currency:'Q.' }}</td>
                    <td>{{ client.totalProfit | currency:'Q.' }}</td>
                    <td>{{ client.totalMargin | percent:'1.2-2' }}</td>
                    </tr>
                    <ng-container *ngIf="client.expanded">
                    <ng-container *ngFor="let warehouse of client.warehouses">
                        <!-- Warehouse Row -->
                        <tr class="fw-bold" (click)="toggleWarehouse(warehouse, $event)">
                        <td></td>
                        <td class="ps-3">
                            <i class="fa" [ngClass]="warehouse.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                            {{ warehouse.name }}
                        </td>
                        <td></td>
                        <td>{{ warehouse.totalUnits }}</td>
                        <td>{{ warehouse.totalSales | currency:'Q.' }}</td>
                        <td>{{ warehouse.totalCost | currency:'Q.' }}</td>
                        <td>{{ warehouse.totalProfit | currency:'Q.' }}</td>
                        <td>{{ warehouse.totalMargin | percent:'1.2-2' }}</td>
                        </tr>
                        <ng-container *ngIf="warehouse.expanded">
                        <tr *ngFor="let product of warehouse.products">
                            <td></td>
                            <td></td>
                            <td>
                            {{ product.name }}
                            </td>
                            <td>{{ product.units }}</td>
                            <td>{{ product.sales | currency:'Q.' }}</td>
                            <td>{{ product.cost | currency:'Q.' }}</td>
                            <td>{{ product.profit | currency:'Q.' }}</td>
                            <td>{{ product.margin | percent:'1.2-2' }}</td>
                        </tr>
                        </ng-container>
                    </ng-container>
                    </ng-container>
                </ng-container>
                </tbody>
                <tfoot>
                  <tr class="table-secondary fw-bold text-center">
                    <td colspan="3">Totales</td>
                    <td>{{ totalUnidades }}</td>
                    <td>{{ totalVenta | currency:'Q.' }}</td>
                    <td>{{ totalCosto | currency:'Q.' }}</td>
                    <td>{{ totalUtilidad | currency:'Q.' }}</td>
                    <td>{{ totalMargen | percent:'1.2-2' }}</td>
                  </tr>
                </tfoot>
            </table>
            <!-- Paginacion -->
            <app-pagination-custom [elements]="pagination"></app-pagination-custom>
            </div>
        </div>
    </div>
  </div>
</div>
